import { useMutation, useQueryClient } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

const NULL_LEVEL2_GUID = '00000000-0000-0000-0000-000000000000';

const postPoRequestApprovalQuery = (payload) => {
  const raw = payload.level2Approver ?? '';
  const level2Approver = (typeof raw === 'string' && raw.trim() === '') || raw == null
    ? NULL_LEVEL2_GUID
    : String(raw).trim();
  const body = {
    purchaseOrderId: payload.purchaseOrderId,
    approvalAction: payload.approvalAction,
    approverComments: payload.approverComments ?? '',
    level2Approver
  };
  return axios.post(apiurl?.getPoRequestApproval, body);
};

const postPoRequestApproval = () => {
  const queryClient = useQueryClient();
  return useMutation(['postPoRequestApproval'], postPoRequestApprovalQuery, {
    onSuccess: (_, variables) => {
      if (variables?.purchaseOrderId) {
        const poId = variables.purchaseOrderId;
        queryClient.invalidateQueries('getPO');
        queryClient.refetchQueries('getPO');
        queryClient.invalidateQueries('getPoApprovalFlowLog');
        queryClient.invalidateQueries(['getAdvanceRequestPurchaseOrder', poId]);
        queryClient.refetchQueries(['getAdvanceRequestPurchaseOrder', poId]);
      }
    }
  });
};

export default postPoRequestApproval;
